const getSessionTitle = ({ step, bin = false, isEditingSession }) => {
  if (bin) {
    switch (step) {
      case 1:
        return 'Sale Details';
      case 2:
        return isEditingSession ? 'Bulk Upload/Edit Items' : 'Upload Items';
      case 3:
        return 'Upload Images';
      case 4:
        return 'Preview Sale';
      case 5:
          return 'Preview Session';
      case 6:
        return 'Review & Publish';
      case 7:
          return 'Shipping Summary';
      default:
        return null;
    }
  } else {
    switch (step) {
      case 1:
        return 'Create Session';
      case 2:
        return 'Session Details';
      case 3:
        return isEditingSession ? 'Bulk Upload/Edit Items' : 'Upload Items';
      case 4:
        return 'Upload Images';
      case 5:
        return 'Preview Session';
      case 6:
        return 'Review & Publish';
      case 7:
        return 'Shipping Summary';
      default:
        return null;
    }
  }
};

export default getSessionTitle;
